import React from 'react';
import PropTypes from 'prop-types';

import TextField from '../../TextField/TextField';

export class ValueEditorText extends React.Component {
  onChange = (event) => {
    this.props.onChange(event.target.value);
  };

  render() {
    return (
      <TextField
        value={this.props.value}
        style={this.props.style}
        onChange={this.onChange}
        disabled={this.props.disabled}
        autoFocus={this.props.autoFocus}
      />
    );
  }
}

ValueEditorText.propTypes = {
  value: PropTypes.any,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  onChange: PropTypes.func,
};
